import BaseEntity from '../base/BaseEntity.model';
import Persona from '../persona/persona.model';
import NameValue from '../nameValue.model';

export default class Miembro extends BaseEntity {
    public personaId?: number;
    public parentescoId?: number;
    public codigoMiembro?: string;
    public codigoSiuben?: string;
    public excluido?: boolean;
    public fechaExclusion?: Date;
    public fechaInclusion?: Date;
    public persona?: Persona;
    public nombreCompleto?: string;
    public parentescoNombre?: string;
    public parentescoCodigo?: string;
    public hogarId?: number;
    public codigoHogar?: string;
    public razonInclusionId?: number;
    public razonInclusion?: NameValue;
    public razonInclusionOtro?: string;
    
    public razonExclusionId?: number;
    public razonExclusion?: NameValue;
    public razonMuerte?: string;
    public fechaFallecimiento?: Date;

    public cedulaQuienPoseeMenor?: string;
   
    public parentescoQuienPoseeMenorId?: number;

    constructor() {
        super();
        this.init();
    }

    init() {
        this.id = undefined;
        this.nombreCompleto = undefined;
        this.personaId = undefined;
        this.hogarId = undefined;
        this.parentescoId = undefined;
        this.codigoMiembro = undefined;
        this.codigoSiuben = undefined;
        this.codigoHogar = undefined;
        this.excluido = undefined;
        this.fechaExclusion = undefined;
        this.fechaInclusion = undefined;
        this.persona = undefined;
        this.parentescoNombre = undefined;
        this.razonInclusionOtro = undefined;
        this.razonInclusionId = undefined;
        this.razonInclusion = new NameValue();

        this.razonExclusionId = undefined;
        this.razonExclusion = new NameValue();
        this.razonMuerte = undefined;
        this.fechaFallecimiento = undefined;

        this.cedulaQuienPoseeMenor = undefined;
        this.parentescoQuienPoseeMenorId =undefined;
    }
}
